<template lang="pug">
  #app
    div(v-if="token")
      Navbar(:token="token" :userProfile="userProfile" :loginStatus="data.loginStatus" :key="$route.fullPath")
      .mainWrapper
        .mainwrapper-menu
          SideMenu(:type="type" :sidemenu='data.sidemenu' :token='token' :userProfile="userProfile" :loginStatus="data.loginStatus" :key="$route.fullPath")
        .mainWrapper-content
          router-view(:data='data' :key="$route.fullPath" :breadcrumbList='breadcrumbs')
      Footer(:copyright='data.footer.copyright' :elements='data.footer.elements')
    div(v-else)
      router-view(:data='data' :key="$route.fullPath")
</template>
<script>
import StaticData from "@/assets/data.json";
import Navbar from "@/components/nav/navbar.vue";
import SideMenu from "@/components/menu/side_menu.vue";
import Footer from "@/components/footer.vue";
import { logout } from "@/plugins/login.js";
import { getUserProfile } from "@/plugins/login.js";

export default {
  components: {
    Navbar,
    SideMenu,
    Footer,
  },
  data() {
    return {
      data: null,
      token: localStorage.getItem(this.$store.state.storageKeys.token),
      userProfile: {
        displayName: null,
        pictureUrl: null,
        userId: null,
      },
      type: localStorage.getItem(this.$store.state.storageKeys.identity),
      breadcrumbs: [
        {
          text: "首頁",
          link: "/",
        },
      ],
    };
  },
  created() {
    this.data = StaticData[this.$store.state.lang];
  },
  async mounted() {
    if (this.token != null) {
      const userInfo = getUserProfile(this.$store.state.storageKeys);
      this.token = userInfo[0];
      this.userProfile.displayName = userInfo[1];
      this.userProfile.pictureUrl = userInfo[2];

      let identity = localStorage.getItem(
        this.$store.state.storageKeys.identity
      );
      if (identity == "partners") {
        let route = this.$store.state.URLs.apiPartner + "/token";
        this.$axios
          .post(route, null, {
            headers: {
              "X-Line-Biz-Session": this.token,
              "Content-Type": "application/x-www-form-urlencoded",
            },
          })
          .then()
          .catch((error) => {
            if (error.response.status == "403") logout(this.$store.state);
          });
      }
    }
  },
};
</script>
<style src="./partner.vue.css"></style>
